<div class="row">
	<div class="col-lg-10 offset-lg-1 col-12 jmDashTitle">
		<div class="row">
			<div class="col-12 jmNoPaddingCol">
				<div class="jmDashTitleBlock">&nbsp;</div>
			</div>
			<div class="col-12">
				<app-navigation-history></app-navigation-history>
			</div>
		</div>
	</div>
</div>

<div class="row" style="margin-top: 10px; margin-bottom: 50px;">
	<div [ngClass]="!mobileView?'col-sm-3 offset-sm-1':'col-10 offset-1'">
		<div class="border" style="font-size:12px; padding:10px; background-color:#fff">
			<div style="font-size:16px;">
				<b>Edit Search</b>
				<div *ngIf="enableReset" (click)="resetFilter()" style="float:right;font-size:10px; color:#b1b1b0; cursor:pointer;" onmouseover="this.style.color='#3ca2df';" onmouseout="this.style.color='#b1b1b0';">Reset</div>
			</div>
			<div style="margin-top:15px;">
				<div style="font-size:13px"><b>School Name</b></div>
				<div id="CSCSChoolNameField" style="margin:5px 10px;">
					<input #schoolNameSearchBox
						   name="selectedSchool"
						   [ngModelOptions]="{standalone: true}"
						   type="text"
						   class="form-control"
						   style="font-size:10px;"
						   maxlength="100"
						   autocomplete="off"
						   typeahead-editable="false"
						   placeholder="e.g. USA University"
						   [(ngModel)]="CSCSrv.searchFilter.selectedSchool"
						   (focus)="searchSchoolNameFocus($event)"
						   (blur)="blurSchoolNameSelection()"
						   (selectItem)="selectSchoolName($event)"
						   [ngbTypeahead]="searchSchoolName"
						   [resultTemplate]="searchSchoolNameResult"
						   [inputFormatter]="searchSchoolNameInput"
						   #instance="ngbTypeahead" />
					<ng-template #searchSchoolNameResult let-r="result">
						<span style="white-space:normal;">{{r.Name}}</span>
					</ng-template>
				</div>
			</div>
			<div style="margin-top:15px;">
				<div style="font-size:13px"><b>Academic Fields</b></div>
				<div style="margin:5px 10px;">
					<input #programSearchBox
						   name="selectedProgram"
						   [ngModelOptions]="{standalone: true}"
						   type="text"
						   class="form-control"
						   style="font-size:10px;"
						   maxlength="100"
						   autocomplete="off"
						   typeahead-editable="false"
						   placeholder="Type to search"
						   [(ngModel)]="CSCSrv.searchFilter.selectedProgram"
						   (focus)="searchProgramFocus($event)"
						   (blur)="blurProgramSelection()"
						   (selectItem)="selectProgram($event)"
						   [ngbTypeahead]="searchProgram"
						   [resultTemplate]="searchProgramResult"
						   [inputFormatter]="searchProgramInput"
						   #instance="ngbTypeahead" />
					<ng-template #searchProgramResult let-r="result">
						<span style="white-space:normal;">{{r.Title}}</span>
					</ng-template>
				</div>
			</div>
			<div style="margin-top:15px;">
				<div style="font-size:13px"><b>Degrees/Certificate</b></div>
				<div style="margin:5px 10px;">
					<div *ngFor="let option of CSCSrv.degreeOptions">
						<input name="Degree" type="checkbox" value="{{option.Value}}" [(ngModel)]="CSCSrv.searchFilter.Degree[option.Value]" /> {{option.Text}}
					</div>
				</div>
			</div>
			<div style="margin-top:15px;">
				<div style="font-size:13px"><b>Location</b></div>
				<div style="margin:5px 10px;">
					State<br />
					<select name="State" [(ngModel)]="CSCSrv.searchFilter.State" class="form-select" style="font-size:10px;">
						<option [ngValue]="option.Value" *ngFor="let option of CSCSrv.stateOptions">{{option.Text}}</option>
					</select>
				</div>
				<div style="margin:5px 10px;">
					Region<br />
					<select name="Region" [(ngModel)]="CSCSrv.searchFilter.Region" class="form-select" style="font-size:10px;">
						<option [ngValue]="option.Value" *ngFor="let option of CSCSrv.regionOptions">{{option.Text}}</option>
					</select>
				</div>
				<div class="row" style="margin:5px 0px;">
					<div class="col-6">
						ZIP code<br /><input name="ZipCode" [(ngModel)]="CSCSrv.searchFilter.ZipCode" type="text" autocomplete="off" placeholder="e.g. 45000" class="form-control" style="font-size:10px;" />
					</div>
					<div class="col-6">
						Mile radius<br /><input name="Mile" [(ngModel)]="CSCSrv.searchFilter.Mile" type="text" autocomplete="off" class="form-control" style="font-size:10px;" onkeypress="return event.charCode >= 48 && event.charCode <= 57" />
					</div>
				</div>
			</div>
			<div style="margin-top:15px;">
				<div style="font-size:13px"><b>Size</b></div>
				<div style="margin:5px 10px;">
					<div *ngFor="let option of CSCSrv.studentSizeOptions">
						<input name="StudentSize" type="checkbox" value="{{option.Value}}" [(ngModel)]="CSCSrv.searchFilter.StudentSize[option.Value]" /> {{option.Text}}
					</div>
				</div>
			</div>

			<div style="margin-top:15px;">
				<div style="font-size:13px"><b>Type of school</b></div>
				<div style="margin:5px 10px;">
					<div *ngFor="let option of CSCSrv.schoolTypeOptions">
						<input name="SchoolType" type="checkbox" value="{{option.Value}}" [(ngModel)]="CSCSrv.searchFilter.SchoolType[option.Value]" /> {{option.Text}}
					</div>
				</div>
			</div>
			<div style="margin-top:15px;">
				<div style="font-size:13px"><b>Urbanicity</b></div>
				<div style="margin:5px 10px;">
					<div *ngFor="let option of CSCSrv.urbanicityOptions">
						<input name="Urbanicity" type="checkbox" value="{{option.Value}}" [(ngModel)]="CSCSrv.searchFilter.Urbanicity[option.Value]" /> {{option.Text}}
					</div>
				</div>
			</div>
			<div style="margin-top:15px;">
				<div style="font-size:13px"><b>Specialized Mission</b></div>
				<div style="margin:5px 10px;">
					<select name="SpecializedMission" [(ngModel)]="CSCSrv.searchFilter.SpecializedMission" class="form-select" style="font-size:10px;">
						<option [ngValue]="option.Value" *ngFor="let option of CSCSrv.specializedMissionOptions">{{option.Text}}</option>
					</select>
				</div>
			</div>
			<div style="margin-top:15px;">
				<div style="font-size:13px"><b>Religious Affiliation</b></div>
				<div style="margin:5px 10px;">
					<select name="ReligiousAffiliation" [(ngModel)]="CSCSrv.searchFilter.ReligiousAffiliation" class="form-select" style="font-size:10px;">
						<option [ngValue]="option.Value" *ngFor="let option of CSCSrv.religiousAffiliationOptions">{{option.Text}}</option>
					</select>
				</div>
			</div>
			<div class="row" style="margin-top:20px;">
				<div class="col-6 offset-3">
					<button class="btn btn-primary col-12" (click)="searchSchool()">Find Schools</button>
				</div>
			</div>
		</div>
	</div>

	<!-- search result -->
	<div id="divCSCSearchResult" [ngClass]="!mobileView?'col-sm-7':'col-10 offset-1'" class="row" [ngStyle]="{'margin-top':(mobileView?'20px':'0px')}">
		<div class="border" style="padding:10px; background-color:#fff; width:100%;">
			<div style="font-size:16px; margin-bottom:20px; font-weight:bold;">
				Search Results
				<span *ngIf="searchResultTotal() != null">({{searchResultTotal()}})</span>
			</div>
			<div *ngIf="CSCSrv.searchResult.Status===0" style="height:800px;"> <!-- init --> </div>
			<div *ngIf="CSCSrv.searchResult.Status===1" class="jmWidgetLoadingIcon40"></div>
			<div *ngIf="CSCSrv.searchResult.Status===2">
				<div class="row">
					<div *ngFor="let school of CSCSrv.searchResult.Schools" class="col-lg-4 col-md-12" [ngClass]="{'territoryCardViewAllMediaHeight':!mobileView}" style="margin-bottom: 15px;">
						<div class="border" style="height:100%; padding:10px;">
							<app-territory-card [normalizedData]="convertSchool(school)" [flagFromViewAll]="flagFromViewAll"></app-territory-card>
						</div>
					</div>
				</div>
				<div *ngIf="searchResultTotal() > 6" style="display:flex; justify-content:center; margin:0px 10px;">
					<ngb-pagination [collectionSize]="CSCSrv.searchResult.Total"
									[(page)]="CSCSrv.searchResult.CurrentPage"
									[maxSize]="5"
									[pageSize]="6"
									(pageChange)="changeSearchPage()">
					</ngb-pagination>
				</div>
			</div>
			<div *ngIf="CSCSrv.searchResult.Status==3" style="height:800px;">
				<div class="panel panel-default panel-body">
					<div [innerHtml]="CSCSrv.searchResult.Message"></div>
				</div>
			</div>
		</div>
	</div>
</div>
